const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const imageUrlsByPlaceId = new Map<string, string[]>();
const pendingImageRequests = new Map<string, Promise<string[]>>();

export const getCachedPlaceImageUrls = (placeId: string): Promise<string[]> => {
  const cachedUrls = imageUrlsByPlaceId.get(placeId);
  if (cachedUrls) return Promise.resolve(cachedUrls);

  const pendingRequest = pendingImageRequests.get(placeId);
  if (pendingRequest) return pendingRequest;

  const request = fetch(`${BASE_URL}/api/places/${placeId}/`)
    .then(async (response) => {
      if (!response.ok) throw new Error("Failed to fetch place images");
      const body = await response.json();
      const place = body.data ?? body;
      const imageUrls = (place.images ?? [])
        .map((image: { file_url?: string }) => image.file_url)
        .filter((url: string | undefined): url is string => Boolean(url));

      imageUrlsByPlaceId.set(placeId, imageUrls);
      return imageUrls;
    })
    .catch(() => {
      imageUrlsByPlaceId.set(placeId, []);
      return [];
    })
    .finally(() => {
      pendingImageRequests.delete(placeId);
    });

  pendingImageRequests.set(placeId, request);
  return request;
};
